(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseDetailController', ExpenseDetailController);

    ExpenseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Expense'];

    function ExpenseDetailController($scope, $rootScope, $stateParams, entity, Expense) {
        var vm = this;
        vm.expense = entity;
        vm.load = function (id) {
            Expense.get({id: id}, function(result) {
                vm.expense = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:expenseUpdate', function(event, result) {
            vm.expense = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
